import React from 'react';
import {
  RoomAudioRenderer,
  LiveKitRoom as BaseLiveKitRoom,
  LiveKitRoomProps,
} from '@livekit/components-react';
import styled from 'styled-components';
import { VoiceRoom } from '../VoiceRoom/VoiceRoom';

const { REACT_APP_NOVA_VOICE_WEBSOCKET_URL } = process.env;

const LiveKitRoom =
  BaseLiveKitRoom as unknown as React.ComponentType<LiveKitRoomProps>;

const FullSizeRoom = styled(LiveKitRoom)`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

type VoiceRoomContainerProps = {
  voiceAccessToken: string;
  onLeaveChat(): void;
  onError(): void;
  handleHelpRequired(): void;
};

export const VoiceRoomContainer = ({
  voiceAccessToken,
  onLeaveChat,
  onError,
  handleHelpRequired,
}: VoiceRoomContainerProps) => (
  <FullSizeRoom
    token={voiceAccessToken}
    serverUrl={REACT_APP_NOVA_VOICE_WEBSOCKET_URL}
    connect={true}
    audio={true}
  >
    <RoomAudioRenderer />
    <VoiceRoom
      onLeaveChat={onLeaveChat}
      onError={onError}
      onHelpRequired={handleHelpRequired}
    />
  </FullSizeRoom>
);
